import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × APPLE: Rational translucency
// White voids, glass reflections, rounded geometry
export function VasarelyAppleMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Pure white background */}
      <defs>
        <linearGradient id="apple-glass" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="50%" stopColor="#F8F8F8" />
          <stop offset="100%" stopColor="#FFFFFF" />
        </linearGradient>
        <radialGradient id="apple-glow">
          <stop offset="0%" stopColor={brand.aqua} stopOpacity="0.2" />
          <stop offset="100%" stopColor={brand.aqua} stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#apple-glass)" />

      <g transform="translate(397 540)">
        {/* Rounded geometry grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 54;
            const y = (j - 7.5) * 50;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 24}
                y={y - 22}
                width="48"
                height="44"
                fill="none"
                stroke="#E0E0E0"
                strokeWidth="1"
                rx="12"
                opacity="0.4"
              />
            );
          })
        )}

        {/* Glass reflection layers */}
        {Array.from({ length: 10 }).map((_, i) => {
          const offset = i * 8;
          return (
            <rect
              key={i}
              x={-140 + offset}
              y={-120 + offset}
              width={280 - offset * 2}
              height={240 - offset * 2}
              fill="none"
              stroke="#D8D8D8"
              strokeWidth="1"
              rx="30 - offset"
              opacity={0.25 - i * 0.02}
            />
          );
        })}

        {/* Translucent circles */}
        {Array.from({ length: 16 }).map((_, i) => {
          const r = 40 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#C8C8C8"
              strokeWidth="1"
              opacity={0.3 - i * 0.016}
            />
          );
        })}

        {/* Precision nodes (minimal design) */}
        {[0, 72, 144, 216, 288].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 190;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="40"
                fill="url(#apple-glow)"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="14"
                fill={brand.white}
                stroke="#B0B0B0"
                strokeWidth="2"
                opacity="0.8"
              />
            </g>
          );
        })}

        {/* Empathy lines (human-centered) */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 230}
              y2={Math.sin(angle) * 230}
              stroke="#D0D0D0"
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Central void (white space) */}
        <circle cx="0" cy="0" r="80" fill={brand.white} opacity="0.9" />
        <circle cx="0" cy="0" r="80" fill="none" stroke="#C0C0C0" strokeWidth="2" opacity="0.6" />
        
        {/* Subtle apple shape suggestion */}
        <circle cx="0" cy="5" r="50" fill={brand.white} stroke="#A0A0A0" strokeWidth="2" opacity="0.5" />
        <ellipse cx="0" cy="-30" rx="20" ry="15" fill={brand.white} stroke="#A0A0A0" strokeWidth="2" opacity="0.5" />
        
        {/* Minimal accent */}
        <circle cx="0" cy="0" r="4" fill={brand.aqua} opacity="0.6" />
      </g>

      {/* Apple text */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="11" fill="#999" opacity="0.7">
        translucidité rationnelle
      </text>
    </g>
  );
}
